import { createContext, useContext, useEffect, useState } from "react";
import GetTransactionOrderType from "../../api-layer/transaction-order-type-api/GetTransactionOrderType";
import { useAuth } from "../../auth/auth-provider/auth-provider";

const TransactionOrderTypeContext = createContext();


export const TransactionOrderTypeProvider = ({children}) => {
    const auth = useAuth()
    
    const [transactionOrderTypes, setTtransactionOrderTypes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        getTransactionOrderTypes();
    }, [
        transactionOrderTypes?.length,
        auth?.token,
    ]);


    const getTransactionOrderTypes = () => {
        setLoading(true);
        GetTransactionOrderType().then(
            response => {
                setTtransactionOrderTypes(response.data);
            }
        ).catch(
            error => {
                setError(error);
            }
        ).finally(            
            () => {
                setLoading(false);
            }
        )
    }

    return (
        <TransactionOrderTypeContext.Provider value={{
            transactionOrderTypes,
            loading,
            error,
        }}>
            {children}
        </TransactionOrderTypeContext.Provider>
    );
}

export const useTransactionOrderTypes = () => {
    const context = useContext(TransactionOrderTypeContext);
    return context;
}